import { useGetApplicationQuery, useGetEligibleLoansQuery } from "@/lib/redux";
import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import { useMemo } from "react";
import LoanOfferCard from "./LoanOfferCard";
import { GET_PRODUCT_APPLICATION, IMAGES, PRODUCTS, STAGE } from "@/lib/constants";
import { LoaderComponent } from "@/components";
import { useRouter } from "@/i18n/routing";
import useErrorHandling from "@/lib/hooks/errorhandling";
import useStageErrorHandler from "@/lib/hooks/stageErrorHandler";
import { useTranslations } from "next-intl";



export default function PreApprovedOffer() {
  const t = useTranslations("Dashboard");


  const {
    data: applicationData,
    isLoading: fetchingApplications,
    error: applicationFetchError,
  } = useGetApplicationQuery(undefined, {
    refetchOnMountOrArgChange: 5,  // since already calling for the PL card
  });

  const parentApplication = GET_PRODUCT_APPLICATION(
    PRODUCTS.PL,
    applicationData?.data,
  );

  const repeatLoanApplication = GET_PRODUCT_APPLICATION(
    PRODUCTS.RL,
    applicationData?.data,
  );

  const parentApplicationDisbursed = parentApplication?.stage === STAGE.DISBURSED;
  const rlDisbursed = repeatLoanApplication?.stage === STAGE.DISBURSED;

  const {
    data: eligibleLoansData,
    isLoading: isLoadingEligibleLoans,
    error: errorEligibleLoans,
  } = useGetEligibleLoansQuery(undefined, {
    skip: !parentApplicationDisbursed,
    refetchOnMountOrArgChange: true,
  });

  const preApprovedLoansList = useMemo(() => {
    return eligibleLoansData?.data?.filter((i) => Boolean(i.active)) || [];
  }, [eligibleLoansData]);



  // useErrorHandling(errorEligibleLoans);

  if (preApprovedLoansList?.length === 0) return null;
  return (
    <Box
      sx={{
        width: {
          xs: "94%", // mobile
          sm: "97%", // tablet
          md: "66%", // desktop
          lg: "65%!important", // large screen
        },
      }}>
      <LoaderComponent open={isLoadingEligibleLoans || fetchingApplications} />
      <Stack gap={1} mb={3}>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Image src={IMAGES.leftWindow} alt="Hero" />
          <Typography variant="h6">
            {rlDisbursed ? t("repeatLoanDisbursed") : t("preApprovedOffers")}
          </Typography>
        </Stack>
      </Stack>
      {preApprovedLoansList?.length > 0 &&
        preApprovedLoansList?.map((offer, idx) => (
          <LoanOfferCard key={idx} offer={offer} />
        ))}
    </Box>
  );
}
